import { render, staticRenderFns } from "./DraftDLG.vue?vue&type=template&id=4d96d27e&scoped=true"
import script from "./DraftDLG.vue?vue&type=script&lang=ts"
export * from "./DraftDLG.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./DraftDLG.vue?vue&type=style&index=0&id=4d96d27e&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4d96d27e",
  "bffdcb30"
  
)

export default component.exports